import { Component } from '@angular/core';

/**
 * Task 2616 Phase 7 — Startup error page.
 * Shown when the NavBar or Questionnaire API returns a typed dependency_unavailable (503).
 * Must not use the normal application layout, sidebar resolver, permission guard or NavBar.
 */
@Component({
  standalone: false,
  selector: 'app-startup-error',
  template: `
    <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100vh;font-family:sans-serif;">
      <h1 style="font-size:2rem;margin-bottom:1rem;">Service temporarily unavailable</h1>
      <p style="color:#666;margin-bottom:2rem;">A required service is not responding. Please try again in a few moments.</p>
      <a href="/" style="padding:0.75rem 1.5rem;background:#0078d4;color:#fff;border-radius:4px;text-decoration:none;">
        Try again
      </a>
    </div>
  `,
})
export class StartupErrorComponent {}
